module.exports = __webpack_public_path__ + "media/images/main/SAPC5456-026f7be66a89f94a5f92f4bc638d50e3.png";